import { ComponentEx } from "../../../controls/ComponentEx";
import * as fs from "../../../util/fs";
import { userFriendlyTime } from "../../../util/relativeTime";
import * as path from "path";
import * as React from "react";
class FileTime extends ComponentEx {
    mIsMounted = false;
    constructor(props) {
        super(props);
        this.initState({ mtime: undefined });
    }
    componentDidMount() {
        this.mIsMounted = true;
        this.updateTime();
    }
    componentWillUnmount() {
        this.mIsMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.time === undefined &&
            (this.props.downloadPath !== nextProps.downloadPath ||
                this.props.download !== nextProps.download)) {
            this.updateTime();
        }
    }
    render() {
        const { t, detail, language, time } = this.props;
        const mtime = time || this.state.mtime;
        if (mtime === undefined) {
            return null;
        }
        if (detail) {
            try {
                return React.createElement("span", null, mtime.toLocaleString(language));
            }
            catch (err) {
                return React.createElement("span", null, mtime.toISOString());
            }
        }
        else {
            return React.createElement("span", null, userFriendlyTime(mtime, t, language));
        }
    }
    updateTime() {
        const { download, downloadPath } = this.props;
        if (download.localPath === undefined || downloadPath === undefined) {
            return null;
        }
        else {
            return fs
                .statAsync(path.join(downloadPath, download.localPath))
                .then((stat) => {
                if (this.mIsMounted) {
                    this.nextState.mtime = stat.mtime;
                }
            })
                .catch((err) => undefined);
        }
    }
}
export default FileTime;
